import { Post } from "../models/Post";

const positiveTime = (value?: number) => value && value > 0 ? value : undefined;

/** Keep scheduled slots stable and include queued, active, and failed publish-now attempts. */
export function calendarConnectionTimes(post: Post): Record<string, number | undefined> {
  const connections = Object.entries(post.connections || {});
  const postTime = positiveTime(post.scheduledFor);
  const hasSchedule = connections.some(([, connection]) => positiveTime(connection.scheduledFor) ?? postTime);
  const publishedTimes = connections.flatMap(([, connection]) =>
    connection.status === "published" && positiveTime(connection.publishedAt) ? [connection.publishedAt!] : []
  );
  const attemptTimes = connections.flatMap(([, connection]) => {
    const time = positiveTime(connection.publishAttemptStartedAt)
      ?? positiveTime(connection.pendingPublishStartedAt)
      ?? positiveTime(connection.pendingPublishInitializationStartedAt);
    return time ? [time] : [];
  });
  const sharedAttemptTime = !hasSchedule && attemptTimes.length ? Math.min(...attemptTimes) : undefined;
  const sharedPublishedTime = !hasSchedule && publishedTimes.length ? Math.min(...publishedTimes) : undefined;
  return Object.fromEntries(connections.map(([id, connection]) => [id,
    positiveTime(connection.scheduledFor) ?? postTime ?? (
      connection.status === "published" ? sharedAttemptTime ?? sharedPublishedTime ?? positiveTime(connection.publishedAt)
        : connection.status === "failed" ? sharedAttemptTime ?? sharedPublishedTime ?? positiveTime(connection.error?.timestamp) ?? positiveTime(post.updatedAt)
          : connection.status === "pre-processing" || connection.status === "publishing" ||
              (connection.status === "pending" && (Boolean(connection.taskName) || post.status === "scheduled"))
            ? sharedAttemptTime ?? sharedPublishedTime ?? positiveTime(post.updatedAt)
            : undefined
    ),
  ]));
}
